import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Clipboard18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path d='M13 8.75H8V7.25H13V8.75Z' fill='currentColor' />
    <path d='M8 12.75H13V11.25H8V12.75Z' fill='currentColor' />
    <path
      d='M7 8C7 8.55229 6.55228 9 6 9C5.44772 9 5 8.55229 5 8C5 7.44772 5.44772 7 6 7C6.55228 7 7 7.44772 7 8Z'
      fill='currentColor'
    />
    <path
      d='M6 13C6.55228 13 7 12.5523 7 12C7 11.4477 6.55228 11 6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 0.25C6.41093 0.25 6.25 0.768637 6.25 1.25H2.5C1.81917 1.25 1.25 1.81917 1.25 2.5V16.5C1.25 17.1808 1.81917 17.75 2.5 17.75H15.5C16.1808 17.75 16.75 17.1808 16.75 16.5V2.5C16.75 1.81917 16.1808 1.25 15.5 1.25H11.75C11.75 0.768637 11.5891 0.25 11 0.25H7ZM11.75 2.75V4C11.75 4.41421 11.4142 4.75 11 4.75H7C6.58579 4.75 6.25 4.41421 6.25 4V2.75H2.75V16.25H15.25V2.75H11.75ZM10.25 3.25H7.75V1.75H10.25V3.25Z'
      fill='currentColor'
    />
  </Svg>
);

Clipboard18.displayName = 'Clipboard18';
export default Clipboard18;
